const TEMPLATE_TYPE_OPTIONS = {
  NEW: 'new',
  UPDATE: 'update',
} as const

type TemplateType = (typeof TEMPLATE_TYPE_OPTIONS)[keyof typeof TEMPLATE_TYPE_OPTIONS]

export { type TemplateType, TEMPLATE_TYPE_OPTIONS }
